export default __webpack_public_path__ + "static/AromaIcon-c4a1a14be5a3730da104944093b6854a.png";